import { injectable } from 'inversify';
import { File } from '@/app/shared/models';
import fileBankStoreModule from '@/app/file/file-bank-state';
import aspectStoreModule from '@/app/aspect/apsect-state';

@injectable()
export class FileBankService {
  public getFiles(): File[] {
    if (fileBankStoreModule.files.length > 0) {
      return fileBankStoreModule.files;
    }

    const aspect = aspectStoreModule.selectedCourseAspectInstance;
    if (!aspect) {
      return [];
    }

    return aspect.files;
  }
}

export const FileBankServiceSymbol = Symbol.for('FileBankService');
